import {Placement} from 'common/components/tooltip/types';
import {IconSizeType} from 'common/constants';

import {UserIconAttrs} from '../user-icon';
import {UserType} from './constants';
import {UserListTrackProperties} from './tracking';

export type MixpanelUserItem = Pick<
  UserIconAttrs,
  'img-src' | 'name' | 'id' | 'email' | 'label-prefix' | 'label-suffix'
> & {
  type?: UserType.Mixpanel;
  lastViewedUtcSeconds?: number;
};

export type EditorUser = {
  name?: string;
  email?: string;
  dateStr: string;
};

export interface TrackedUserItem {
  type: UserType.Tracked;
  'distinct-id': string;
  email: string;
  avatar: string;
  'tooltip-text'?: string;
}

export type UserItem = MixpanelUserItem | TrackedUserItem;

export interface UserListAttrs {
  'disable-tooltip'?: boolean;
  'more-text'?: string;
  'max-icons-displayed': number;
  'max-icons-total'?: number;
  'tooltip-placement'?: Placement;
  'user-count-override'?: number;
  clickable?: boolean;
  size?: IconSizeType;
  users?: UserItem[];
  'editor-user'?: EditorUser;
  'track-properties'?: UserListTrackProperties;
}

export function isTrackedUserItem(item: UserItem): item is TrackedUserItem {
  return item.type === UserType.Tracked;
}

export type HeaderUserInfo = {
  id: number;
  name: string;
  email: string;
  date?: string;
};
